import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, vModelRadio as _vModelRadio, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-03165d6a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "marcas-container" };
const _hoisted_2 = { class: "dashboard" };
const _hoisted_3 = { class: "marcas-content" };
const _hoisted_4 = { class: "content-header" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h1", { class: "title" }, "Gestión de Categorías", -1 /* HOISTED */));
const _hoisted_6 = { class: "header-top-controls" };
const _hoisted_7 = { class: "search-wrapper" };
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Generar Reporte", -1 /* HOISTED */));
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Nueva Categoría", -1 /* HOISTED */));
const _hoisted_10 = { class: "filter-controls" };
const _hoisted_11 = { class: "alphabet-filter" };
const _hoisted_12 = ["onClick"];
const _hoisted_13 = { class: "dropdown-filters" };
const _hoisted_14 = { class: "filter-group autocomplete" };
const _hoisted_15 = {
    key: 0,
    class: "autocomplete-list filter-autocomplete"
};
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("em", null, "Todos los Departamentos", -1 /* HOISTED */));
const _hoisted_17 = [
    _hoisted_16
];
const _hoisted_18 = ["onMousedown", "innerHTML"];
const _hoisted_19 = { class: "table-container" };
const _hoisted_20 = { class: "marcas-table" };
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", null, "Nombre"),
        /*#__PURE__*/ _createElementVNode("th", null, "Departamento"),
        /*#__PURE__*/ _createElementVNode("th", null, "Estado"),
        /*#__PURE__*/ _createElementVNode("th", { class: "actions-column" }, "Acciones")
    ])
], -1 /* HOISTED */));
const _hoisted_22 = { key: 0 };
const _hoisted_23 = {
    colspan: "4",
    class: "text-center py-8"
};
const _hoisted_24 = { class: "loading-state" };
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mt-2 text-muted" }, "Cargando categorías...", -1 /* HOISTED */));
const _hoisted_26 = { key: 1 };
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", {
    colspan: "4",
    class: "text-center py-4 text-muted"
}, "No se encontraron categorías.", -1 /* HOISTED */));
const _hoisted_28 = [
    _hoisted_27
];
const _hoisted_29 = { style: { "font-weight": "600", "color": "#1e293b" } };
const _hoisted_30 = { class: "actions-column" };
const _hoisted_31 = ["onClick", "title"];
const _hoisted_32 = ["onClick"];
const _hoisted_33 = ["onClick"];
const _hoisted_34 = { class: "pagination-controls" };
const _hoisted_35 = ["disabled"];
const _hoisted_36 = ["disabled"];
const _hoisted_37 = { class: "total-count-display" };
const _hoisted_38 = {
    key: 0,
    class: "modal-overlay"
};
const _hoisted_39 = { class: "modal-window" };
const _hoisted_40 = { class: "modal-header" };
const _hoisted_41 = { class: "modal-title-group" };
const _hoisted_42 = { class: "icon-bg" };
const _hoisted_43 = { class: "modal-title" };
const _hoisted_44 = { class: "form-group premium-input" };
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Nombre de la Categoría", -1 /* HOISTED */));
const _hoisted_46 = { class: "form-group premium-input" };
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Departamento", -1 /* HOISTED */));
const _hoisted_48 = { class: "autocomplete" };
const _hoisted_49 = {
    key: 0,
    class: "autocomplete-list"
};
const _hoisted_50 = ["onClick", "innerHTML"];
const _hoisted_51 = { class: "modal-footer" };
const _hoisted_52 = ["disabled"];
const _hoisted_53 = { class: "modal-window export-modal premium-modal" };
const _hoisted_54 = { class: "modal-header" };
const _hoisted_55 = { class: "modal-title-group" };
const _hoisted_56 = { class: "icon-bg excel-bg" };
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h2", { class: "modal-title" }, "Generar Reporte"),
    /*#__PURE__*/ _createElementVNode("p", { class: "modal-subtitle" }, "Seleccione los parámetros del reporte")
], -1 /* HOISTED */));
const _hoisted_58 = { class: "modal-body" };
const _hoisted_59 = { class: "export-info-card" };
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "Selecciona el formato y las columnas que deseas incluir en tu reporte. Puedes arrastrar las columnas para reordenarlas.", -1 /* HOISTED */));
const _hoisted_61 = { class: "export-section" };
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "section-label" }, "Formato de Salida", -1 /* HOISTED */));
const _hoisted_63 = { class: "export-format-grid" };
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "export-format-card-content" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "export-format-name" }, "Excel (.xlsx)"),
    /*#__PURE__*/ _createElementVNode("span", { class: "export-format-desc" }, "Hoja de cálculo editable")
], -1 /* HOISTED */));
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "export-format-card-content" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "export-format-name" }, "PDF (.pdf)"),
    /*#__PURE__*/ _createElementVNode("span", { class: "export-format-desc" }, "Documento listo para imprimir")
], -1 /* HOISTED */));
const _hoisted_66 = {
    class: "export-section",
    style: { "margin-top": "24px" }
};
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "section-label" }, "Ordenar Por", -1 /* HOISTED */));
const _hoisted_68 = {
    class: "export-format-grid",
    style: { "grid-template-columns": "2fr 1fr", "gap": "10px" }
};
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "Nombre" }, "Nombre de la Categoría", -1 /* HOISTED */));
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "Departamento" }, "Departamento", -1 /* HOISTED */));
const _hoisted_71 = [
    _hoisted_69,
    _hoisted_70
];
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "asc" }, "Ascendente", -1 /* HOISTED */));
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "desc" }, "Descendente", -1 /* HOISTED */));
const _hoisted_74 = [
    _hoisted_72,
    _hoisted_73
];
const _hoisted_75 = {
    class: "export-section",
    style: { "margin-top": "24px" }
};
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "section-label" }, "Columnas a Incluir", -1 /* HOISTED */));
const _hoisted_77 = { class: "columns-selection-grid" };
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "column-selection-header" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "header-order" }, "#"),
    /*#__PURE__*/ _createElementVNode("span", { class: "header-name" }, "Columna")
], -1 /* HOISTED */));
const _hoisted_79 = { class: "column-order-badge" };
const _hoisted_80 = {
    class: "drag-handle",
    title: "Arrastrar para reordenar"
};
const _hoisted_81 = { class: "checkbox-wrapper" };
const _hoisted_82 = ["value"];
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "checkmark" }, null, -1 /* HOISTED */));
const _hoisted_84 = { class: "column-details" };
const _hoisted_85 = { class: "column-name" };
const _hoisted_86 = { class: "modal-footer" };
const _hoisted_87 = ["disabled"];
const _hoisted_88 = { key: 0 };
const _hoisted_89 = {
    key: 1,
    class: "btn-content"
};
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Generar Reporte", -1 /* HOISTED */));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Header = _resolveComponent("Header");
    const _component_Sidebar = _resolveComponent("Sidebar");
    const _component_SearchIcon = _resolveComponent("SearchIcon");
    const _component_FileTextIcon = _resolveComponent("FileTextIcon");
    const _component_PlusIcon = _resolveComponent("PlusIcon");
    const _component_LayersIcon = _resolveComponent("LayersIcon");
    const _component_Loader2Icon = _resolveComponent("Loader2Icon");
    const _component_PowerIcon = _resolveComponent("PowerIcon");
    const _component_EditIcon = _resolveComponent("EditIcon");
    const _component_TrashIcon = _resolveComponent("TrashIcon");
    const _component_ChevronLeftIcon = _resolveComponent("ChevronLeftIcon");
    const _component_ChevronRightIcon = _resolveComponent("ChevronRightIcon");
    const _component_XIcon = _resolveComponent("XIcon");
    const _component_DownloadIcon = _resolveComponent("DownloadIcon");
    const _component_InfoIcon = _resolveComponent("InfoIcon");
    const _component_GripVerticalIcon = _resolveComponent("GripVerticalIcon");
    const _component_draggable = _resolveComponent("draggable");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Header),
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Sidebar),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_SearchIcon, {
                                size: 18,
                                class: "search-icon"
                            }),
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.searchQuery) = $event)),
                                placeholder: "Buscar categoría...",
                                class: "search-input"
                            }, null, 512 /* NEED_PATCH */), [
                                [_vModelText, $setup.searchQuery]
                            ])
                        ]),
                        _createElementVNode("button", {
                            onClick: _cache[1] || (_cache[1] =
                                //@ts-ignore
                                (...args) => ($setup.openExportModal && $setup.openExportModal(...args))),
                            class: "btn btn-export-premium"
                        }, [
                            _createVNode(_component_FileTextIcon, { size: 18 }),
                            _hoisted_8
                        ]),
                        ($setup.hasPermission('SETTINGS_CREATE'))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: _cache[2] || (_cache[2] = ($event) => ($setup.openModal())),
                                class: "btn btn-add"
                            }, [
                                _createVNode(_component_PlusIcon, { size: 18 }),
                                _hoisted_9
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _createCommentVNode(" Filtros "),
                    _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("button", {
                                onClick: _cache[3] || (_cache[3] =
                                    //@ts-ignore
                                    (...args) => ($setup.resetFilter && $setup.resetFilter(...args))),
                                class: _normalizeClass([{ active: !$setup.selectedLetter }, "alphabet-button all-button"])
                            }, " Todos ", 2 /* CLASS */),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.alphabet, (letter) => {
                                return (_openBlock(), _createElementBlock("button", {
                                    key: letter,
                                    onClick: ($event) => ($setup.filterByLetter(letter)),
                                    class: _normalizeClass([{ active: $setup.selectedLetter === letter }, "alphabet-button"])
                                }, _toDisplayString(letter), 11 /* TEXT, CLASS, PROPS */, _hoisted_12));
                            }), 128 /* KEYED_FRAGMENT */))
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                                _createVNode(_component_LayersIcon, {
                                    size: 16,
                                    class: "filter-icon"
                                }),
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => (($setup.searchFilterDep) = $event)),
                                    onFocus: _cache[5] || (_cache[5] = ($event) => ($setup.showFilterDeps = true)),
                                    onBlur: _cache[6] || (_cache[6] =
                                        //@ts-ignore
                                        (...args) => ($setup.onBlurFilterDep && $setup.onBlurFilterDep(...args))),
                                    placeholder: "Filtrar por Departamento...",
                                    class: "filter-input"
                                }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                    [_vModelText, $setup.searchFilterDep]
                                ]),
                                ($setup.showFilterDeps && $setup.filteredFilterDepsList.length)
                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_15, [
                                        _createElementVNode("li", {
                                            onMousedown: _cache[7] || (_cache[7] =
                                                //@ts-ignore
                                                (...args) => ($setup.clearFilterDep && $setup.clearFilterDep(...args))),
                                            class: "clear-option"
                                        }, _hoisted_17, 32 /* NEED_HYDRATION */),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredFilterDepsList, (dep) => {
                                            return (_openBlock(), _createElementBlock("li", {
                                                key: dep.departamentoID,
                                                onMousedown: ($event) => ($setup.selectFilterDep(dep)),
                                                innerHTML: dep.highlightedNombre
                                            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_18));
                                        }), 128 /* KEYED_FRAGMENT */))
                                    ]))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("table", _hoisted_20, [
                        _hoisted_21,
                        _createElementVNode("tbody", null, [
                            ($setup.isLoading)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [
                                    _createElementVNode("td", _hoisted_23, [
                                        _createElementVNode("div", _hoisted_24, [
                                            _createVNode(_component_Loader2Icon, {
                                                class: "spinner-icon text-primary",
                                                size: 32
                                            }),
                                            _hoisted_25
                                        ])
                                    ])
                                ]))
                                : ($setup.categorias.length === 0)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_26, _hoisted_28))
                                    : _createCommentVNode("v-if", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.categorias, (cat, idx) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                    key: cat.categoriaID
                                }, [
                                    _createElementVNode("td", _hoisted_29, _toDisplayString(cat.nombre), 1 /* TEXT */),
                                    _createElementVNode("td", null, _toDisplayString(cat.departamento?.nombre || $setup.getNombreDepartamento(cat.departamentoID)), 1 /* TEXT */),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            class: _normalizeClass(["status-badge", cat.active ? 'active' : 'inactive'])
                                        }, _toDisplayString(cat.active ? 'Activo' : 'Inactivo'), 3 /* TEXT, CLASS */)
                                    ]),
                                    _createElementVNode("td", _hoisted_30, [
                                        _createElementVNode("button", {
                                            onClick: ($event) => ($setup.toggleActive(cat)),
                                            class: "btn-icon btn-toggle",
                                            title: cat.active ? 'Desactivar' : 'Activar'
                                        }, [
                                            _createVNode(_component_PowerIcon, {
                                                size: 18,
                                                class: _normalizeClass(cat.active ? 'text-success' : 'text-danger')
                                            }, null, 8 /* PROPS */, ["class"])
                                        ], 8 /* PROPS */, _hoisted_31),
                                        ($setup.hasPermission('SETTINGS_EDIT'))
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                onClick: ($event) => ($setup.openModal(cat)),
                                                class: "btn-icon btn-edit",
                                                title: "Editar"
                                            }, [
                                                _createVNode(_component_EditIcon, { size: 18 })
                                            ], 8 /* PROPS */, _hoisted_32))
                                            : _createCommentVNode("v-if", true),
                                        ($setup.hasPermission('SETTINGS_DELETE'))
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 1,
                                                onClick: ($event) => ($setup.confirmDelete(cat.categoriaID)),
                                                class: "btn-icon btn-delete",
                                                title: "Eliminar"
                                            }, [
                                                _createVNode(_component_TrashIcon, { size: 18 })
                                            ], 8 /* PROPS */, _hoisted_33))
                                            : _createCommentVNode("v-if", true)
                                    ])
                                ]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("button", {
                        onClick: _cache[8] || (_cache[8] =
                            //@ts-ignore
                            (...args) => ($setup.prevPage && $setup.prevPage(...args))),
                        disabled: $setup.currentPage === 1,
                        class: "btn-pagination"
                    }, [
                        _createVNode(_component_ChevronLeftIcon, { size: 16 }),
                        _createTextVNode(" Anterior ")
                    ], 8 /* PROPS */, _hoisted_35),
                    _createElementVNode("span", null, [
                        _createTextVNode("Página "),
                        _createElementVNode("strong", null, _toDisplayString($setup.currentPage), 1 /* TEXT */),
                        _createTextVNode(" de "),
                        _createElementVNode("strong", null, _toDisplayString($setup.totalPages), 1 /* TEXT */)
                    ]),
                    _createElementVNode("button", {
                        onClick: _cache[9] || (_cache[9] =
                            //@ts-ignore
                            (...args) => ($setup.nextPage && $setup.nextPage(...args))),
                        disabled: $setup.currentPage === $setup.totalPages,
                        class: "btn-pagination"
                    }, [
                        _createTextVNode(" Siguiente "),
                        _createVNode(_component_ChevronRightIcon, { size: 16 })
                    ], 8 /* PROPS */, _hoisted_36)
                ]),
                _createElementVNode("div", _hoisted_37, "Total Categorías: " + _toDisplayString($setup.totalCount), 1 /* TEXT */),
                _createCommentVNode(" Modal "),
                _createVNode(_Transition, { name: "modal-fade" }, {
                    default: _withCtx(() => [
                        ($setup.isModalOpen)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                _createElementVNode("div", _hoisted_39, [
                                    _createElementVNode("div", _hoisted_40, [
                                        _createElementVNode("div", _hoisted_41, [
                                            _createElementVNode("div", _hoisted_42, [
                                                (!$setup.isEditing)
                                                    ? (_openBlock(), _createBlock(_component_PlusIcon, {
                                                        key: 0,
                                                        size: 22,
                                                        class: "text-primary"
                                                    }))
                                                    : (_openBlock(), _createBlock(_component_EditIcon, {
                                                        key: 1,
                                                        size: 22,
                                                        class: "text-primary"
                                                    }))
                                            ]),
                                            _createElementVNode("h2", _hoisted_43, _toDisplayString($setup.isEditing ? 'Editar Categoría' : 'Nueva Categoría'), 1 /* TEXT */)
                                        ]),
                                        _createElementVNode("button", {
                                            onClick: _cache[10] || (_cache[10] =
                                                //@ts-ignore
                                                (...args) => ($setup.closeModal && $setup.closeModal(...args))),
                                            class: "btn-close-modal"
                                        }, [
                                            _createVNode(_component_XIcon, { size: 22 })
                                        ])
                                    ]),
                                    _createElementVNode("form", {
                                        onSubmit: _cache[15] || (_cache[15] = _withModifiers(
                                        //@ts-ignore
                                        (...args) => ($setup.saveItem && $setup.saveItem(...args)), ["prevent"])),
                                        class: "modal-body"
                                    }, [
                                        _createElementVNode("div", _hoisted_44, [
                                            _hoisted_45,
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => (($setup.currentForm.nombre) = $event)),
                                                placeholder: "Ej: Lubricantes",
                                                required: "",
                                                class: "form-control"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [_vModelText, $setup.currentForm.nombre]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_46, [
                                            _hoisted_47,
                                            _createElementVNode("div", _hoisted_48, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => (($setup.searchDepartamentoText) = $event)),
                                                    onInput: _cache[13] || (_cache[13] =
                                                        //@ts-ignore
                                                        (...args) => ($setup.onSearchDepartamento && $setup.onSearchDepartamento(...args))),
                                                    placeholder: "Buscar y seleccionar departamento...",
                                                    class: "form-control",
                                                    required: ""
                                                }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                                    [_vModelText, $setup.searchDepartamentoText]
                                                ]),
                                                ($setup.filteredDepartamentosForSelect.length > 0 && $setup.searchDepartamentoText.length >= 2 && $setup.showDepartamentoDropdown)
                                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_49, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredDepartamentosForSelect, (dep) => {
                                                            return (_openBlock(), _createElementBlock("li", {
                                                                key: dep.departamentoID,
                                                                onClick: ($event) => ($setup.selectDepartamento(dep)),
                                                                innerHTML: dep.highlightedNombre
                                                            }, null, 8 /* PROPS */, _hoisted_50));
                                                        }), 128 /* KEYED_FRAGMENT */))
                                                    ]))
                                                    : _createCommentVNode("v-if", true)
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_51, [
                                            _createElementVNode("button", {
                                                type: "button",
                                                onClick: _cache[14] || (_cache[14] =
                                                    //@ts-ignore
                                                    (...args) => ($setup.closeModal && $setup.closeModal(...args))),
                                                class: "btn-cancel-modal"
                                            }, "Cancelar"),
                                            _createElementVNode("button", {
                                                type: "submit",
                                                class: "btn-save-modal",
                                                disabled: $setup.isSubmitting
                                            }, _toDisplayString($setup.isSubmitting ? 'Guardando...' : ($setup.isEditing ? 'Actualizar' : 'Registrar')), 9 /* TEXT, PROPS */, _hoisted_52)
                                        ])
                                    ], 32 /* NEED_HYDRATION */)
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                }),
                _createCommentVNode(" Modal Exportar Excel con Diseño Premium "),
                _createVNode(_Transition, { name: "modal-fade" }, {
                    default: _withCtx(() => [
                        ($setup.isExportModalOpen)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "modal-overlay",
                                onClick: _cache[25] || (_cache[25] = _withModifiers(
                                //@ts-ignore
                                (...args) => ($setup.closeExportModal && $setup.closeExportModal(...args)), ["self"]))
                            }, [
                                _createElementVNode("div", _hoisted_53, [
                                    _createElementVNode("div", _hoisted_54, [
                                        _createElementVNode("div", _hoisted_55, [
                                            _createElementVNode("div", _hoisted_56, [
                                                _createVNode(_component_DownloadIcon, {
                                                    size: 24,
                                                    class: "text-excel"
                                                })
                                            ]),
                                            _hoisted_57
                                        ]),
                                        _createElementVNode("button", {
                                            onClick: _cache[16] || (_cache[16] =
                                                //@ts-ignore
                                                (...args) => ($setup.closeExportModal && $setup.closeExportModal(...args))),
                                            class: "btn-close-modal"
                                        }, [
                                            _createVNode(_component_XIcon, { size: 24 })
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_58, [
                                        _createElementVNode("div", _hoisted_59, [
                                            _createVNode(_component_InfoIcon, {
                                                size: 18,
                                                class: "text-primary"
                                            }),
                                            _hoisted_60
                                        ]),
                                        _createElementVNode("div", _hoisted_61, [
                                            _hoisted_62,
                                            _createElementVNode("div", _hoisted_63, [
                                                _createElementVNode("label", {
                                                    class: _normalizeClass(["export-format-card", { active: $setup.exportConfig.format === 'excel' }])
                                                }, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "radio",
                                                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => (($setup.exportConfig.format) = $event)),
                                                        value: "excel",
                                                        hidden: ""
                                                    }, null, 512 /* NEED_PATCH */), [
                                                        [_vModelRadio, $setup.exportConfig.format]
                                                    ]),
                                                    _hoisted_64
                                                ], 2 /* CLASS */),
                                                _createElementVNode("label", {
                                                    class: _normalizeClass(["export-format-card", { active: $setup.exportConfig.format === 'pdf' }])
                                                }, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "radio",
                                                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => (($setup.exportConfig.format) = $event)),
                                                        value: "pdf",
                                                        hidden: ""
                                                    }, null, 512 /* NEED_PATCH */), [
                                                        [_vModelRadio, $setup.exportConfig.format]
                                                    ]),
                                                    _hoisted_65
                                                ], 2 /* CLASS */)
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_66, [
                                            _hoisted_67,
                                            _createElementVNode("div", _hoisted_68, [
                                                _withDirectives(_createElementVNode("select", {
                                                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => (($setup.exportConfig.sortColumn) = $event)),
                                                    class: "form-control",
                                                    style: { "background-color": "#f8fafc", "border": "1px solid #e2e8f0", "border-radius": "8px", "padding": "12px", "font-size": "0.95rem", "color": "#1e293b", "outline": "none", "transition": "border-color 0.2s, box-shadow 0.2s", "cursor": "pointer" }
                                                }, _hoisted_71, 512 /* NEED_PATCH */), [
                                                    [_vModelSelect, $setup.exportConfig.sortColumn]
                                                ]),
                                                _withDirectives(_createElementVNode("select", {
                                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => (($setup.exportConfig.sortDirection) = $event)),
                                                    class: "form-control",
                                                    style: { "background-color": "#f8fafc", "border": "1px solid #e2e8f0", "border-radius": "8px", "padding": "12px", "font-size": "0.95rem", "color": "#1e293b", "outline": "none", "transition": "border-color 0.2s, box-shadow 0.2s", "cursor": "pointer" }
                                                }, _hoisted_74, 512 /* NEED_PATCH */), [
                                                    [_vModelSelect, $setup.exportConfig.sortDirection]
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_75, [
                                            _hoisted_76,
                                            _createElementVNode("div", _hoisted_77, [
                                                _hoisted_78,
                                                _createVNode(_component_draggable, {
                                                    modelValue: $setup.availableColumns,
                                                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => (($setup.availableColumns) = $event)),
                                                    "item-key": "name",
                                                    handle: ".drag-handle",
                                                    class: "draggable-columns-list"
                                                }, {
                                                    item: _withCtx(({ element: column, index }) => [
                                                        _createElementVNode("label", {
                                                            class: _normalizeClass(["column-checkbox-card", { active: $setup.exportConfig.selectedColumns.includes(column.name) }])
                                                        }, [
                                                            _createElementVNode("div", _hoisted_79, _toDisplayString(index + 1), 1 /* TEXT */),
                                                            _createElementVNode("div", _hoisted_80, [
                                                                _createVNode(_component_GripVerticalIcon, { size: 16 })
                                                            ]),
                                                            _createElementVNode("div", _hoisted_81, [
                                                                _withDirectives(_createElementVNode("input", {
                                                                    type: "checkbox",
                                                                    value: column.name,
                                                                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => (($setup.exportConfig.selectedColumns) = $event))
                                                                }, null, 8 /* PROPS */, _hoisted_82), [
                                                                    [_vModelCheckbox, $setup.exportConfig.selectedColumns]
                                                                ]),
                                                                _hoisted_83
                                                            ]),
                                                            _createElementVNode("div", _hoisted_84, [
                                                                _createElementVNode("span", _hoisted_85, _toDisplayString(column.name), 1 /* TEXT */)
                                                            ])
                                                        ], 2 /* CLASS */)
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["modelValue"])
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_86, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            onClick: _cache[23] || (_cache[23] =
                                                //@ts-ignore
                                                (...args) => ($setup.closeExportModal && $setup.closeExportModal(...args))),
                                            class: "btn-cancel-modal"
                                        }, "Cancelar"),
                                        _createElementVNode("button", {
                                            type: "button",
                                            onClick: _cache[24] || (_cache[24] =
                                                //@ts-ignore
                                                (...args) => ($setup.handleExport && $setup.handleExport(...args))),
                                            class: "btn-save-modal btn-excel",
                                            disabled: $setup.isExporting
                                        }, [
                                            ($setup.isExporting)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_88, "Generando..."))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_89, [
                                                    _createVNode(_component_FileTextIcon, { size: 18 }),
                                                    _hoisted_90
                                                ]))
                                        ], 8 /* PROPS */, _hoisted_87)
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                })
            ])
        ])
    ]));
}
